module.exports = __webpack_public_path__ + "img/Stab_OB.800eb7b0.svg";